import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { BrandMark } from "@/components/brand-mark";
import { ThemeToggle } from "@/components/theme-toggle";

export default function NotFoundPage() {
  return (
    <div className="relative min-h-screen bg-background text-foreground bg-grain">
      <header className="flex items-center justify-between px-4 py-4 md:px-8 md:py-6">
        <BrandMark />
        <ThemeToggle />
      </header>
      <main className="mx-auto flex max-w-lg flex-col items-center px-6 pt-32 text-center">
        <div className="text-xs uppercase tracking-widest text-muted-foreground">
          404
        </div>
        <h1 className="mt-2 font-display text-6xl font-black tracking-tight">
          Not here.
        </h1>
        <p className="mt-3 text-muted-foreground">
          This link doesn't exist, moved, or the token expired.
        </p>
        <Button asChild className="mt-8">
          <Link to="/">Back home</Link>
        </Button>
      </main>
    </div>
  );
}
